import type { CustomerJobMetadataPolicy } from '~/lib/customer-job-metadata';

/**
 * MPX: which fields of each service a customer's post may set (lib/customer-
 * job-metadata.ts), by service id. Every field of every service's schema is
 * listed once, customer or office (customer-job-metadata.test.ts).
 */
export const MPX_CUSTOMER_JOB_METADATA: Record<string, CustomerJobMetadataPolicy> = {
  // MpxPhotosForm: the Custom type with its own revenue and expense is the office's; no form sets
  // `instructions`.
  photos: {
    customer: ['community', 'twilight', 'staging', 'type', 'unit', 'photos'],
    office: ['instructions', 'revenue', 'expense'],
    officeValues: { type: ['custom'] },
  },
  microsite: { customer: ['domain'], office: [] },
  google: { customer: ['miles'], office: [] },
  video: { customer: [], office: [] },
  zillow: { customer: ['floorplan'], office: [] },
  floorplan: { customer: ['type'], office: [] },
  aerial: { customer: ['video', 'photos', 'community', 'tour'], office: [] },
  // no form: the model, its link and the interior flag are the office's.
  matterport: {
    customer: ['device', 'exterior', 'google', 'staging', 'floorplan', 'video', 'cad', 'trueplan', 'unit', 'type'],
    office: ['interior', 'model', 'url'],
  },
};
